import styled, { css } from 'styled-components';
import { fontWeight, vars } from '$util/theme';
import { focusRing } from '$base-styles/accessibility/focus-state';

const {
  brandPurple,
  purple200,
  purple300,
  purple400,
  purple500,
  purple600,
  neutral100,
  neutral200,
  neutral300,
  neutral800,
  white,
} = vars.quantumverse.reskinColors;

const baseStyles = css`
  display: inline-flex;
  align-items: center;
  position: relative;
  padding: 8px;
  font-weight: ${fontWeight.semiBold};
  text-decoration: underline;
  color: ${neutral800};
`;

const deprecatedBaseStyles = css`
  column-gap: 14px;
  font-size: 16px;
  line-height: 24px;
  font-weight: 700;
  color: ${purple500};
  text-decoration: none;
`;

export default styled.a`
  ${baseStyles}
  > .qvIcon {
    transition: transform 250ms ease-in-out;
  }
  &:hover {
    > .qvIcon {
      transform: translateX(8px);
    }
  }
  &.L {
    font-size: 18px;
    line-height: 24px;
    column-gap: 12px;
  }
  &.M {
    font-size: 16px;
    line-height: 20px;
    column-gap: 12px;
  }
  &.S {
    font-size: 14px;
    line-height: 18px;
    column-gap: 4px;
  }
  &.XS {
    font-size: 12px;
    line-height: 16px;
    column-gap: 4px;
  }
  &.disabled {
    color: ${neutral300} !important;
  }

  &.L,
  &.M,
  &.S,
  &.XS {
    &:hover,
    &:active,
    &:focus {
      text-decoration: underline;
    }
    &.left {
      flex-direction: row-reverse;
    }
    &:not([href]),
    &[href=''] {
      cursor: inherit;
      &:hover,
      &:active {
        color: ${neutral800};
        text-decoration: underline;
      }
    }

    &.light {
      color: ${white};
      &[href='']:hover,
      &[href='']:active {
        color: ${white};
      }
    }
    &:hover {
      &:not([href='']) {
        color: ${purple500};
        &.light {
          color: ${neutral100};
        }
      }
    }
    &:active {
      &:not([href='']) {
        color: ${purple600};
        &.light {
          color: ${neutral200};
        }
      }
    }
  }
  &.L,
  &.M,
  &.S {
    letter-spacing: -0.01em;
  }
  &.L,
  &.M {
    &.left {
      &:hover {
        > .qvIcon {
          transform: rotate(180deg) translateX(8px);
        }
      }
      > .qvIcon {
        transform: rotate(180deg);
      }
    }
  }
  &.S,
  &.XS {
    &:hover {
      > .qvIcon {
        transform: scale(0.6) translateX(8px); // 9.6px
      }
    }
    &.left {
      &:hover {
        > .qvIcon {
          transform: scale(0.6) rotate(180deg) translateX(8px); // 9.6px
        }
      }
      > .qvIcon {
        transform: rotate(180deg) scale(0.6); // 9.6px
      }
    }
    > .qvIcon {
      transform: scale(0.6); // 9.6px
    }
  }

  /**
   * To remove after we finish the transition to the new design
   */
  &.fat,
  &.big,
  &.small {
    ${deprecatedBaseStyles}
    > .qvIcon {
      transform: scale(0.75); // 12px
    }
    &:hover {
      > .qvIcon {
        transform: scale(0.75) translateX(8px); // 12px
      }
    }
    &:focus {
      ${focusRing}
      border-radius: 6px;
    }
    &.disabled,
    &[href=''] {
      color: ${purple400} !important;
      font-weight: 600px;
    }
    &:not(.fat, :focus) {
      &::after {
        content: '';
        display: block;
        position: absolute;
        bottom: 8px;
        left: 8px;
        width: 0;
        height: 0;
      }
    }
    &:hover {
      &::after {
        width: calc(100% - 8px);
        height: 1px;
        @media (-webkit-device-pixel-ratio: 2), (min-resolution: 2dppx) {
          height: 1.5px;
        }
        background-color: currentColor;
      }
    }
  }
  &.fat {
    line-height: 28px;
    padding: 18px 20px;
    background-color: ${purple200};
    border-radius: 6px;
    &.color-bg {
      background-color: ${white};
      box-shadow: inset 0 0 0 2px ${purple500};
      @media (-webkit-device-pixel-ratio: 2), (min-resolution: 2dppx) {
        box-shadow: inset 0 0 0 1.5px ${purple500};
      }
    }

    &:hover {
      background-color: ${purple300};
      &.color-bg {
        background-color: ${purple200};
      }
    }

    &:active {
      background-color: ${purple200};
      &.color-bg {
        background-color: ${white};
      }
    }
    &.disabled,
    &[href=''] {
      background-color: ${purple200};
      &.color-bg {
        background-color: ${white};
        box-shadow: inset 0 0 0 2px ${purple400};
        @media (-webkit-device-pixel-ratio: 2), (min-resolution: 2dppx) {
          box-shadow: inset 0 0 0 1.5px ${purple400};
        }
      }
    }
  }
  &.big {
    font-size: 20px;
    font-weight: 600;
    padding: 6px 8px;
  }

  > .Link__icon {
    &.purple-icon {
      color: ${white};
      > svg {
        transform: scale(${16 / 0.24 / 100});
        z-index: 1;
      }

      &::after {
        content: '';
        display: block;
        width: 24px;
        height: 24px;
        border-radius: 12px;
        position: absolute;
        background-color: ${brandPurple};
      }
    }
  }
`;
